import { table } from './_table';

export const time_conditions = {
  namespaced: true,
  modules: {
    table
  }
};
